import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { TTransactionStatus } from '../../../../../api/src';
import { useURLContractId } from '../../layouts/ContractIdLayout/ContractIdLayout';
import { usePagerPropsFromUrl } from '../pager/use-pager-props-from-url';
import { useToasts } from '../use-toasts';
import { usePayoutsQuery } from './queries';

export const useWithdrawalStatusToast = () => {
  // Observe the latest payouts even when the table is on another page.
  const { data } = usePayoutsQuery('withdrawals', { page: 1 });
  const contractId = useURLContractId();
  const { PageSize } = usePagerPropsFromUrl();
  const toasts = useToasts();
  const { t } = useTranslation(['transactionStatus']);
  const previousRef = useRef<{
    contractId: number | undefined;
    pageSize: number;
    statuses: Map<number, TTransactionStatus>;
  } | null>(null);

  useEffect(() => {
    const previous = previousRef.current;
    // Navigation must not turn historical payouts into new notifications.
    if (
      previous?.contractId !== contractId ||
      previous?.pageSize !== PageSize
    ) {
      previousRef.current = null;
    }
    if (!data) return;

    const statuses = new Map(data.items.map(({ id, status }) => [id, status]));
    if (previousRef.current) {
      for (const [id, status] of statuses) {
        if (previousRef.current.statuses.get(id) === status) continue;

        if (status === 'Credited') {
          toasts.success(t(status));
        } else if (status === 'Rejected' || status === 'RejectedOnlyCredit') {
          toasts.error(t(status));
        }
      }
    }
    previousRef.current = { contractId, pageSize: PageSize, statuses };
  }, [contractId, PageSize, data, t, toasts]);
};
